import React, { Suspense } from "react";
import Loader from "../component/Loader";
const LoginPage = React.lazy(() => import("../app/login"));

function Login() {
  return (
    <>
      <Suspense fallback={<Loader />}>
        <LoginPage />
      </Suspense>
    </>
  );
}

export default Login;
